import React from 'react'
import PropTypes from 'prop-types'
import Section, { ExpandedContent, SectionHeader } from './Section'
import pluralize from 'pluralize'
import CommodityCodes from './CommodityCodes'
import CommodityCodesShape from './prop_shapes/commodity_codes'

const CommodityCodeSection = ({ commodityCodes: { count, items }, editButton }) => {
  const calloutText = () => {
    if (count > 0) {
      return `${count} ${pluralize('Commodity', count).toUpperCase()}`
    } else {
      return ''
    }
  }

  return (
    <Section
      expandable
      idText='commodity-codes'
      padded
    >
      <SectionHeader
        callout={calloutText()}
        idText='commodity-codes'
        editButton={editButton}
      >
        Commodities
      </SectionHeader>

      <ExpandedContent>
        <CommodityCodes
          commodityCodes={items}
        />
      </ExpandedContent>
    </Section>
  )
}

CommodityCodeSection.propTypes = {
  commodityCodes: CommodityCodesShape,
  editButton: PropTypes.element
}

export default CommodityCodeSection
